<template>
  <div class="progress-section">
    <div class="sec-title" :class="title==='第三方检测报告'?'title-img2':'title-img'" v-show="title!==''">
      <span class="title">{{title}}</span>
    </div>
    <div class="sec-content" v-show="title==='工程进度'">
      <div v-for="(item, index) in itemsData" :key="'items'+index">
        <!-- 工程进度-->
        <div class="content-top">
          <div class="con-title" v-show="item.mediumTitle!==''">
            <span class="title fz16 fzweight550">{{item.mediumTitle}}</span>
          </div>
          <div class="description" v-if="item.isSonItems">完成比</div>
        </div>
        <div class="progress-con" v-if="item.isSonItems">
          <div v-for="(son, i) in item.sonItems" :key="'items'+i">
            <div class="flex-columns">
              <div class="left-column">{{son.progress_type}}</div>
              <div class="center-column">
                <el-progress
                  :percentage="son.datarate"
                  :stroke-width="10"
                  :show-text="false"
                  class="el-bg-inner-running"
                ></el-progress>
              </div>
              <div v-if="item.mediumTitle == '工程总进度'" class="right-column fz16">{{son.datarate}}%</div>
              <div v-else class="right-column fr" :class="item.isSonItems?'fz16':'fz36 '">{{son.datarate}}%</div>
            </div>
            <div class="flex-rows" @mousewheel.prevent>
              <vue-seamless-scroll :data="getChildrenBuild(son)" class="child-seamless-warp" :class-option="classOption">
                <div class="row-column" v-for="(item,index) in getChildrenBuild(son)" :key="index">
                  <div class="row-column-child">
                    <div class="top">{{item.typeNum}}%</div>
                    <div class="bottom">{{item.typeName}}</div>
                  </div>
                </div>
                <!-- <div class="row-column">
                  <div class="top">{{son.progress_build}}%</div>
                  <div class="bottom">基础结构</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_steelwork}}%</div>
                  <div class="bottom">钢结构</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_canopy}}%</div>
                  <div class="bottom">金属屋面 雨棚</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_wall}}%</div>
                  <div class="bottom">金属幕墙</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_second}}%</div>
                  <div class="bottom">二次结构</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_electrical}}%</div>
                  <div class="bottom">机电施工</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_decorate}}%</div>
                  <div class="bottom">装饰工程</div>
                </div>
                <div class="row-column">
                  <div class="top">{{son.progress_services}}%</div>
                  <div class="bottom">市政工程</div>
                </div> -->

              </vue-seamless-scroll>

            </div>
          </div>
        </div>
        <div class="progress-con" v-else>
          <div class="flex-columns">
            <div class="left-column">{{item.des}}</div>
            <div class="center-column">
              <el-progress
                :percentage="item.rate"
                :stroke-width="10"
                :show-text="false"
                class="el-bg-inner-running"
              ></el-progress>
            </div>
            <div v-if="item.mediumTitle == '工程总进度'" class="right-column fz36">{{item.rate}}%</div>
            <div
              v-else
              class="right-column fr"
              :class="item.isSonItems?'fz36':'fz16'"
            >{{item.rate}}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-content qualityArea" v-show="title==='总工程'">
      <div v-for="(item, index) in itemsData" :key="'items'+index">
        <div class="flex-rows p20">
          <div class="row-column-two width140">
            <div class="top-two">{{item.name1}}</div>
            <div class="bottom-two">{{item.num1}}</div>
          </div>
          <div class="row-column-two">
            <div class="top-two">{{item.name2}}: {{item.num2}}%</div>
            <div class="progress-two">
              <el-progress
                :percentage="item.num2"
                :stroke-width="10"
                :show-text="false"
                class="el-bg-inner-running"
              ></el-progress>
            </div>
          </div>
          <div class="row-column-two">
            <div class="top-two">{{item.name3}}: {{item.num3}}%</div>
            <div class="progress-two">
              <el-progress
                :percentage="item.num3"
                :stroke-width="10"
                :show-text="false"
                class="el-bg-inner-running"
              ></el-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-content" v-show="title==='分部工程'">
      <el-row type="flex" class="row-bg margin20" justify="space-around" align="middle">
        <el-col :span="5">
          <div class="row-logs-title"></div>
        </el-col>
        <el-col :span="7">
          <div class="row-logs-title">建设阶段</div>
        </el-col>
        <el-col :span="6">
          <div class="row-logs-title">检查结果</div>
        </el-col>
        <el-col :span="6">
          <div class="row-logs-title"></div>
        </el-col>
      </el-row>
      <ul>
        <vue-seamless-scroll :data="itemsData" class="seamless-warp" :class-option="classOptionchild">
          <li class="font-FFFFFF-50" v-for="(item,index) in itemsData" :key="index">
            <el-row type="flex" class="row-bg" justify="space-around" align="top">
              <el-col :span="5" class="fz16 colorF">{{item.daxing_childrentype}}</el-col>
              <el-col :span="7" class="fz16 colorF">{{item.daxing_childrenstage}}</el-col>
              <el-col :span="6" class="fz16" :class="item.firststate=='1' ? 'c00C853' : 'cFD0E84'">
                <span>
                  {{item.firstresult}}
                </span>
              </el-col>
              <el-col :span="6" class="fz16" :class="item.secondstate=='1' ? 'c00C853' : 'cFD0E84'"> 
                <span>
                  {{item.secondresult}}
                </span>
              </el-col> 
            </el-row>
          </li>
        </vue-seamless-scroll>
      </ul>
    </div>
    <div class="sec-content" v-show="title==='第三方检测报告'">
      <div class="flex-rows">
        <div class="row-column-two">
          <div class="top-two-16">检查总数(项)</div>
          <div class="bottom-two">{{itemsData[0]}}</div>
        </div>
        <div class="row-column-two">
          <div class="top-two-16">通过率: {{itemsData[1]}}%</div>
          <div class="progress-two">
            <el-progress
              :percentage="itemsData[1] * 1"
              :stroke-width="10"
              :show-text="false"
              class="el-bg-inner-running"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "ProgressSection", // 商机状态
  components: {
    vueSeamlessScroll
  },
  props: {
    title: {
      // 工程进度标题
      type: String,
      default: "概算金额"
    },
    itemsData: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      options: [],
      percentage: 20,
      // childrenBuild1:[
      //   {
      //     typeNum: 10,
      //     typeName: '基础结构'
      //   },
      //   {
      //     typeNum: 20,
      //     typeName: '钢结构'
      //   },
      //   {
      //     typeNum: 30,
      //     typeName: '金属屋面 雨棚'
      //   },
      //   {
      //     typeNum: 40,
      //     typeName: '二次结构'
      //   },
      //   {
      //     typeNum: 50,
      //     typeName: '机电施工'
      //   },
      //   {
      //     typeNum: 70,
      //     typeName: '装饰工程'
      //   },
      //   {
      //     typeNum: 20,
      //     typeName: '市政工程'
      //   }
      // ],
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOptionchild() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {},
  methods: {
    getChildrenBuild(data) {
      let children = []
      // for(let item of this.$project.projectData.constructionType) {
      //   children.push({
      //     typeNum: data[`progress_${item.field}`],
      //     typeName: item.name
      //   })
      // }
      for(let item of data.file_date) {
        children.push({
          typeNum: item.progress_Value,
          typeName: item.progress_Name
        })
      }
      return children;
    }
  }
};
</script>
<style lang="less" scoped>
.fz16 {
  font-family: SourceHanSansCN;
  font-size: 16px;
  font-weight: 500;
  
}
.fr{
  width: 70px;
  text-align: right;
}
.fl{
  width: 70px;
  text-align: left;
}
.fzweight550 {
  font-weight: 550;
}
.fz36 {
  font-family: SourceHanSansCN;
  font-size: 36px;
  font-weight: 500;
  
}

.fz32 {
  font-family: SourceHanSansCN;
  font-size: 32px;
  font-weight: 400;
}
.op5 {
  opacity: 0.5;
}
.colorF {
  color: rgba(255, 255, 255, 0.5);
}
.colorB {
  color: #26abff;
}
.theTop {
  color: #00c853;
}
.theBottom {
  color: #fd0e84;
}
.p20 {
  padding-bottom: 20px;
}
.progress-section {
  padding: 20px 20px 0;
  padding-bottom: 0;
  .sec-title {
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 18px;
      font-family: SourceHanSansCN;
      color: #26abff;
      font-weight: 550;
    }
  }
  .title-img {
    width: 100px;
    height: 36px;
    background: url("../../assets/images/airDataBoard/title_board.png")
      no-repeat;
    background-size: cover;
  }
  .title-img2 {
    width: 150px;
    height: 36px;
    background: url("../../assets/images/airDataBoard/title2_board.png")
      no-repeat;
    background-size: cover;
  }
  .sec-content {
    background: linear-gradient(rgba(7, 17, 41, 0.8), rgba(19, 31, 54, 0.8));
    border-radius: 2px;
    padding-bottom: 13px;
    margin-top: 10px;
    .content-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin: 17px 15px 20px 0;
      .con-title {
        width: 120px;
        height: 30px;
        background: url("../../assets/images/airDataBoard/medium_title_board.png")
          no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        .title {
          color: #26abff;
        }
      }
      .description {
        font-size: 16px;
        font-family: SourceHanSansCN;
        font-weight: 550;
        color: #ffb224;
      }
    }
    .progress-con {
      .flex-columns {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 15px 20px;
        .left-column {
          font-size: 16px;
          font-family: SourceHanSansCN;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.5);
          width: 70px;
          text-align: center;
        }
        .center-column {
          width: 120px;
        }
        .right-column {
          font-family: AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffb224;
        }
      }
    }
    .flex-rows {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      margin-bottom: 5px;
      .row-column-child {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .top {
          font-size: 24px;
          font-family: AlibabaPuHuiTi;
          font-weight: 500;
          color: #26abff;
          height: 30px;
          line-height: 30px;
        }
        .bottom {
          font-size: 16px;
          font-family: SourceHanSansCN;
          font-weight: 500;
          width: 95%;
          min-height: 30px;
          color: rgba(255, 255, 255, 0.5);
          white-space: pre-wrap;
          overflow: hidden; 
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; 
          display: -webkit-box;
        }
      }
      .row-column-two.width140{
        width: 140px;
        height: 45px;
      }
      .row-column-two {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 120px;
        .top-two {
          font-size: 14px;
          font-family: SourceHanSansCN;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.5);
        }
        .top-two-16 {
          font-size: 16px;
          font-family: SourceHanSansCN;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.5);
          margin-top: 20px;
          margin-bottom: 15px;
        }
        .bottom-two {
          font-size: 24px;
          font-family: AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffffff;
        }
        .progress-two {
          width: 80px;
          margin-top: 15px;
        }
      }
    }
    .child-seamless-warp{
      width: 415px;
      // height: 100px;
      overflow-x: auto;
      white-space: nowrap;
      .row-column{
        width: 100px;
        text-align: center;
        display: inline-block;
      }
    }
    ul {
      margin: 0px 20px 0px 20px;
      max-height: 120px;
      overflow-y: auto;
      li {
        min-height: 30px;
        .list-num {
          display: inline-block;
        }
      }
    }
    .margin20{
      margin: 0 20px;
    }
    .row-bg {
      .row-logs-title {
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
  .qualityArea {
    padding: 10px 10px 0 30px;
    margin-top: 10px;
  }
}
.el-progress {
  width: 100%;
}
.el-bg-inner-running /deep/ .el-progress-bar__inner {
  background-color: rgba(71, 96, 255);
}
.el-bg-inner-running /deep/ .el-progress-bar__outer {
  background-color: #1b283d;
}
.c00C853{
  color: #7BD3C6;
}
.cFD0E84{
  color: #DD5252;
}
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>

